

import React, { useState, useEffect, useContext } from 'react';
import { useSnackbar } from 'notistack';
import { AuthContext } from '../context/AuthContext';
import { 
  Box, 
  CircularProgress, 
  Typography, 
  Paper, 
  Button, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow 
} from '@mui/material';

import { getHesapBilgileri } from '../services/api'; 




const themeColor = '#F97316'; 
const themeColorDark = '#EA580C'; 

const HesapBilgilerim = () => {
  const [billings, setBillings] = useState([]);
  const [loading, setLoading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const { token } = useContext(AuthContext); 

  useEffect(() => {
    const fetchBillingData = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const response = await getHesapBilgileri(); 
        setBillings(response.data.data || []);
      } catch (err) {
        enqueueSnackbar(`Hesap bilgileri alınamadı: ${err.message}`, { variant: 'error' });
      } finally {
        setLoading(false);
      }
    };
    
    fetchBillingData();
  }, [token, enqueueSnackbar]); 

  const handlePayment = (faturaId) => {
    enqueueSnackbar(`Ödeme işlemi başlatılıyor... Fatura ID: ${faturaId}`, { variant: 'info' });
  };

  const formatDate = (dateInput) => {
    if (!dateInput) return '-';
    let date;
    if (typeof dateInput === 'object' && dateInput.year) {
      date = new Date(dateInput.year, dateInput.month - 1, dateInput.day);
    } else if (typeof dateInput === 'string') {
      date = new Date(dateInput);
    } else {
      return '-';
    }
    if (isNaN(date.getTime())) {
      return 'Geçersiz Tarih';
    }
    return date.toLocaleDateString('tr-TR');
  };

  const formatCurrency = (num) => {
    const number = Number(num);
    if (isNaN(number)) return '₺0,00';
    return number.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
  }

  const tableHeaders = [
    "Tarih",
    "Sonraki Fatura Tarihi",
    "Paket Adı",
    "Fatura No",
    "Tutar",
    "KDV Tutar",
    "Genel Toplam",
    "Ödeme Durumu",
    "İşlem"
  ];

  return (
    <Paper sx={{ p: { xs: 1, sm: 2, md: 3 }, mt: 2, borderRadius: 2, boxShadow: 3 }}>
      <Typography variant="h5" gutterBottom component="div" sx={{ mb: 2, fontWeight: 'bold' }}>
        Hesap Bilgilerim ve Faturalar
      </Typography>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 4 }}>
          <CircularProgress sx={{ color: themeColor }} />
          <Typography sx={{ ml: 2 }}>Veriler yükleniyor...</Typography>
        </Box>
      ) : (
        <TableContainer component={Paper} variant="outlined">
          <Table stickyHeader size="small" aria-label="hesap bilgileri tablosu">
            <TableHead>
              {/* TableRow'dan arkaplan rengi kaldırıldı */}
              <TableRow>
                {tableHeaders.map(header => (
                  <TableCell 
                    key={header} 
                    align={["Tutar", "KDV Tutar", "Genel Toplam", "İşlem"].includes(header) ? 'right' : 'left'}
                    
                    sx={{ 
                      backgroundColor: themeColor,
                      fontWeight: 'bold', 
                      color: 'white' 
                    }} 
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {billings.length > 0 ? billings.map((bill) => (
                <TableRow key={bill.CARI_ID || bill.FATURA_NO} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell><b>{formatDate(bill.TARIH)}</b></TableCell>
                  <TableCell>{formatDate(bill.SONRAKI_FATURA_TARIH)}</TableCell>
                  <TableCell>{bill.PAKET_ADI}</TableCell>
                  <TableCell>{bill.FATURA_NO || '-'}</TableCell>
                  <TableCell align="right">{formatCurrency(bill.TUTAR)}</TableCell>
                  <TableCell align="right">{formatCurrency(bill.KDV_TUTAR)}</TableCell>
                  <TableCell align="right"><b>{formatCurrency(bill.GENEL_TOPLAM)}</b></TableCell>
                  <TableCell>
                    <Box 
                      component="span" 
                      sx={{
                        padding: '4px 8px',
                        borderRadius: '12px',
                        fontWeight: 'bold',
                        fontSize: '0.75rem',
                        color: bill.ODEME_DURUMU === 'Ödendi' ? '#1e8e3e' : '#d9534f',
                        backgroundColor: bill.ODEME_DURUMU === 'Ödendi' ? 'rgba(46, 204, 113, 0.1)' : 'rgba(231, 76, 60, 0.1)'
                      }}
                    >
                      {bill.ODEME_DURUMU}
                    </Box>
                  </TableCell>
                  <TableCell align="right">
                    {bill.ODEME_DURUMU !== 'Ödendi' && (
                      <Button 
                        variant="contained"
                        size="small"
                        onClick={() => handlePayment(bill.CARI_ID)}
                        sx={{
                          backgroundColor: themeColor,
                          '&:hover': {
                            backgroundColor: themeColorDark,
                          },
                          textTransform: 'none',
                          fontWeight: 'bold',
                          boxShadow: 'none'
                        }}
                      >
                        Ödeme Yap
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              )) : (
                <TableRow>
                  <TableCell colSpan={tableHeaders.length} align="center">
                    Görüntülenecek fatura bilgisi bulunamadı.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default HesapBilgilerim;